// =============================================================================
// requests/api.js
//
// O Dashboard é read-only: precisa apenas de LER todas as atividades a que o
// utilizador tem acesso. Reutiliza exatamente o mesmo endpoint da view
// ActivityTracker (GetAll), que já aplica o Vendor scope + role no servidor —
// ou seja, o dashboard nunca mostra mais do que o utilizador pode ver.
// =============================================================================

import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE = `${config.API_URL}ActivityTracker`;

export const apiGetAll = () =>
	AxiosRequest({ method: 'GET', url: `${BASE}/GetAll` });
